import { isNumeric } from "mathjs";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { cacheSearch, cacheSortColumn, deleteCachedSearch } from "./actions";
import { SearchOptions } from "./types";

const initialState = {};

const searchCacheReducer = reducerWithInitialState<Readonly<SearchOptions>>(
  initialState
)
  .case(cacheSearch, (state, params) => {
    // if the active tab changes let's set the page back to 0 and update the spreadFilter
    if (isNumeric(params.activeTab)) {
      params.spreadFilter = { active: params.activeTab === 0 };
      params.page = 0;
    }

    // if the query changes let's set the page back to 0
    if (state.query !== params.query) {
      params.page = 0;
    }

    const newState = { ...state, ...params };

    return newState;
  })
  .case(deleteCachedSearch, (state, params) => {
    return initialState;
  })
  .case(cacheSortColumn, (state, sortColumn) => {
    if (state.spreadSort) {
      const sortAscending =
        sortColumn === state.spreadSort.sortColumn
          ? !state.spreadSort.sortAscending
          : false;

      return {
        ...state,
        spreadSort: {
          sortColumn,
          sortAscending,
        },
      };
    } else {
      return state;
    }
  });

export default searchCacheReducer;



// WEBPACK FOOTER //
// ./src/searchCache/reducer.ts